module.exports = __webpack_public_path__ + "img/map.c4b57465.jpg";